(function () {
    'use strict';

    /* ══ INTERSECTION OBSERVER ══ */
    // Targets stat cards and process steps for reveal animations
    const obsItems = document.querySelectorAll('.stat-card, .proc-step-r');
    const io = new IntersectionObserver(entries => {
        entries.forEach(e => {
            if (e.isIntersecting) {
                e.target.classList.add('vis');
                const counter = e.target.querySelector('.counter');
                if (counter && !counter.dataset.done) animCounter(counter);
            }
        });
    }, { threshold: 0.1 });

    obsItems.forEach(el => io.observe(el));

    // Fallback for items already in viewport or small delays
    setTimeout(() => {
        obsItems.forEach(el => {
            const r = el.getBoundingClientRect();
            if (r.top < window.innerHeight) {
                el.classList.add('vis');
                const counter = el.querySelector('.counter');
                if (counter && !counter.dataset.done) animCounter(counter);
            }
        });
    }, 500);

    /* ══ COUNTER ANIMATION ══ */
    function animCounter(el) {
        el.dataset.done = '1';
        const target = parseInt(el.dataset.target);
        const isCoffee = !!el.dataset.coffee;
        const dur = isCoffee ? 1800 : 1400;
        const start = performance.now();
        const chars = '0123456789';

        /* animate bar alongside counter */
        const card = el.closest('.stat-card');
        const bar = card && card.querySelector('.stat-bar-fill');
        if (bar) {
            const pct = parseFloat(bar.dataset.pct) || 0;
            setTimeout(() => { bar.style.width = pct + '%'; }, 80);
        }

        function tick(now) {
            const prog = Math.min((now - start) / dur, 1);
            const ease = 1 - Math.pow(1 - prog, 3);
            if (isCoffee) {
                if (prog < 0.85) {
                    el.textContent = chars[Math.floor(Math.random() * 10)] + chars[Math.floor(Math.random() * 10)] + chars[Math.floor(Math.random() * 10)];
                } else {
                    el.textContent = '∞';
                    const suf = document.getElementById('inf-suf');
                    if (suf) suf.style.display = 'none';
                    /* slam bar to 100% */
                    if (bar) bar.style.width = '100%';
                    return;
                }
            } else {
                el.textContent = Math.round(ease * target);
            }
            if (prog < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
    }

    /* ══ CLOCK SYNC ══ */
    function tickClock() {
        const d = new Date(), p = v => String(v).padStart(2, '0');
        const el = document.getElementById('about-clk');
        if (el) el.textContent = 'SYNC::' + p(d.getHours()) + ':' + p(d.getMinutes()) + ':' + p(d.getSeconds());
    }
    setInterval(tickClock, 1000);
    tickClock();

    /* ══ MOBILE OPTIMIZATION ══ */
    // Grid reveal is handled by the IntersectionObserver above

})();
